
import { LatLng } from "../types";

// Get current user position with safe fallback
export const getCurrentPosition = (): Promise<LatLng> => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      console.warn("Geolocation not supported. Using fallback.");
      resolve({ lat: 35.6166, lng: -5.2667 }); // Martil, Morocco
      return;
    }

    // Explicit JS timeout to catch hanging browser API
    const timeoutId = setTimeout(() => {
      console.warn("Geolocation timed out via JS wrapper. Using fallback.");
      resolve({ lat: 35.6166, lng: -5.2667 }); // Martil, Morocco Fallback
    }, 15000); // Extended to 15s for high accuracy GPS lock

    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(timeoutId);
        console.log(`📍 GPS: ${position.coords.latitude.toFixed(6)}, ${position.coords.longitude.toFixed(6)} (accuracy: ${position.coords.accuracy}m)`);
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      },
      (error) => {
        clearTimeout(timeoutId);
        console.warn("Geolocation Error/Denied:", error.message);
        resolve({ lat: 35.6166, lng: -5.2667 }); // Martil, Morocco Fallback
      },
      {
        enableHighAccuracy: true,  // Enable GPS for precise location
        timeout: 12000,            // 12s timeout for GPS lock
        maximumAge: 10000          // Only accept 10-second old cached positions
      }
    );
  });
};

export const generateNearbyCoordinates = (center: LatLng, radiusKm: number): LatLng => {
  const y0 = center.lat;
  const x0 = center.lng;
  const rd = radiusKm * 1000 / 111300;

  const u = Math.random();
  const v = Math.random();

  const w = rd * Math.sqrt(u);
  const t = 2 * Math.PI * v;
  const x = w * Math.cos(t);
  const y = w * Math.sin(t);

  const newLat = y + y0;
  const newLng = x / Math.cos(y0 * (Math.PI / 180)) + x0;

  return { lat: newLat, lng: newLng };
};

// Real Reverse Geocoding via OSM Nominatim
export const getCyberLocationName = async (lat: number, lng: number, lang: 'en' | 'ar'): Promise<string> => {
  try {
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=12&addressdetails=1`, {
      headers: {
        'User-Agent': 'LaNajaApp/1.0'
      }
    });

    if (!response.ok) throw new Error("GeoAPI Failed");

    const data = await response.json();
    let district = data.address.suburb || data.address.district || data.address.city || data.address.town || data.address.village;

    if (!district) return `SECTOR ${lat.toFixed(2).slice(-2)}`;

    // Aesthetic Cyber Formatting
    if (lang === 'ar') {
      return `${district} - قطاع ${lat.toFixed(2).slice(-2)}`;
    }
    return `${district.toUpperCase()} • SEC ${lat.toFixed(2).slice(-2)}`;
  } catch (e) {
    return `SECTOR ${lat.toFixed(2).slice(-2)} • ZONE ${lng.toFixed(2).slice(-2)}`;
  }
};
